import { UID } from 'shared/api/query/constants';
import { customerContract as customerContractConfig } from 'shared/api/query/configs.json';

export const customerContractEdges = [
  { attr: UID },
  { attr: customerContractConfig.edges.startedAt },
  { attr: customerContractConfig.edges.accountType },
];
